import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home.vue'
import Video from './components/Video.vue'
import Wait from './components/Wait.vue'
import IPWebcam from './components/IPWebcam.vue'
import Screen from './components/ScreenTask.vue'


Vue.use(Router)

export default new Router({
  // mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
  // base: '',
  routes: [
    { path: '/', component: Wait },
    { path: '/ipwebcam/:ip', component: IPWebcam },
    { path: '/screen/:ip', component: Screen },
    { path: '/wait', component: Wait },
    { path: '/video', component: Video },
    { path: '/lic/:license?', component: Home, name:'home' },
    

    // {
      // path: '/about',
      // name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
